import { lazyInitializeExtensibilityContext } from 'owa-addins-core/lib/lazyFunctions';
import initializeNotifications from './initializeNotifications';
import initializePersona from './initializePersona';
import { lazyLoadAllowedOptions } from 'owa-allowed-options';
import { lazyValidateCache } from 'owa-boot-cache';
import { getBrandsSubscriptionsService } from 'owa-brands-subscription';
import { setupErrorHandler } from 'owa-exception-handler-devtools';
import { isFeatureEnabled } from 'owa-feature-flags';
import { initializeBindStatusLazy } from 'owa-linkedin';
import { lazyLoadCLPUserLabels } from 'owa-mail-protection';
import { initialize as initializeDefaultSettingsExperiment } from 'owa-mail-defaultsettings';
import { initializeMailFavicon } from 'owa-mail-favicon';
import { lazyInitializeMailOptinService } from 'owa-mail-optin';
import { lazySetup } from 'owa-notification';
import { lazyLoadSignature } from 'owa-mail-signature';
import { lazyLoadOptions } from 'owa-outlook-service-options';
import shouldUse3SPeopleSuggestions from 'owa-recipient-suggestions/lib/util/shouldUse3SPeopleSuggestions';
import { lazyRegisterAndInitializeSharedABT } from 'owa-shared-activity-based-timeout';
import { lazyExecute3SPrimeCall } from 'owa-substrate-people-suggestions';
import { lazyPinLikeSurfaceAction } from 'owa-surface-actions-option';
import { getTrustedSendersAndDomains } from 'owa-trusted-senders';
import { lazyGovern } from 'owa-shared-post-boot';
import { isCacheFirstEnabled } from 'owa-readwrite-recipient-well/lib/actions/people/isCacheFirstEnabled';
import { lazyInitializeCache } from 'owa-recipient-cache';
import { lazyInitializeProxyAddressStore } from 'owa-proxy-address-option';
import isBusiness from 'owa-session-store/lib/utils/isBusiness';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function setupMailDeeplinkCommonPostRender(isFullApp?: boolean) {
    initializePersona();
    initializeMailFavicon();

    lazyGovern.importAndExecute(
        setupErrorHandler,
        {
            condition: !isCacheFirstEnabled(),
            task: () => lazyInitializeCache.importAndExecute(),
        },
        () => lazyLoadSignature.importAndExecute(),
        {
            condition: isFeatureEnabled('cmp-clp') && !isConsumer(),
            task: () => lazyLoadCLPUserLabels.importAndExecute(),
        },
        {
            condition: shouldUse3SPeopleSuggestions(),
            task: () => lazyExecute3SPrimeCall.importAndExecute(),
        },
        {
            condition: !isConsumer(),
            task: () => lazyLoadAllowedOptions.importAndExecute(),
        },
        () => lazySetup.importAndExecute(),
        () => lazyLoadOptions.importAndExecute(),
        {
            condition: isFeatureEnabled('cmp-proxy-address') && !isConsumer(),
            task: () => lazyInitializeProxyAddressStore.importAndExecute(),
        },
        {
            condition: isFeatureEnabled('rp-linkedInViewProfile'),
            task: () => initializeBindStatusLazy.importAndExecute(),
        },
        {
            task: () => lazyRegisterAndInitializeSharedABT.importAndExecute(),
            condition:
                isBusiness() &&
                isFeatureEnabled('auth-sharedActivityBasedTimeout') &&
                getUserConfiguration().PolicySettings.IsSharedActivityBasedTimeoutEnabled,
            idle: isFullApp,
        },
        {
            task: () => lazyInitializeExtensibilityContext.importAndExecute(),
            condition: isFeatureEnabled('rp-addins'),
            idle: isFullApp,
        },
        {
            task: initializeNotifications,
            idle: isFullApp,
        },
        {
            task: getTrustedSendersAndDomains,
            idle: isFullApp,
        },
        {
            condition:
                isFeatureEnabled('rp-infoBarBrandSubscription') ||
                isFeatureEnabled('tri-unsubscribeLV'),
            task: () => getBrandsSubscriptionsService(true /* dont load brands info */),
            idle: isFullApp,
        },
        {
            task: () => lazyPinLikeSurfaceAction.importAndExecute(),
            idle: isFullApp,
        },
        {
            task: () => lazyInitializeMailOptinService.importAndExecute(),
            idle: isFullApp,
        },
        {
            task: () => lazyValidateCache.importAndExecute(),
            idle: isFullApp,
        },
        {
            task: initializeDefaultSettingsExperiment,
            idle: isFullApp,
        }
    );
}
